import { CREATE_FAST_USER_SUCCESS } from '../constants/ActionTypes';

export default function createFastUserSuccess(state, action) {
    switch (action.type) {
        case CREATE_FAST_USER_SUCCESS:
            return true
        default:
            return state
    }
}
